import { HcResponseMeaning } from "./hc-response-meaning.enum";
import { HcResponseAction, HcTimeOutAction } from "./hc-response-actions.enum";
import { HcVoice } from "./hc-voice.model";
import { HcAudioRecording } from "./hc-audio-recording.model";
import { HcMessageStrings } from "../health-check/strings/hc-message-strings";

/**
 * When `postAnswerGreetingDelaySeconds` is omitted or invalid, voice calls use this delay after connect before the greeting.
 * An explicit stored value of `0` still means no wait.
 */
export const HC_DEFAULT_POST_ANSWER_GREETING_DELAY_SECONDS = 1.5;

export interface HcPhoneSetup {
  _id: string;
  csId: string;

  voiceId?: string; // Reference to HcVoice for instructions/confirmations
  voice?: HcVoice; // Populated on queries

  voiceOptions: HcVoiceOptions;
  greeting: HcMessage | HcAudioRecording | null;
  /**
   * After Twilio reports the call answered, wait this many seconds (fractions allowed, e.g. 0.5) before playing the greeting + prompts.
   * Omitted uses {@link HC_DEFAULT_POST_ANSWER_GREETING_DELAY_SECONDS}. Set to `0` for no extra wait.
   */
  postAnswerGreetingDelaySeconds?: number;
  audioFileIdsToDelete?: string[]; // Audio file IDs to delete when the flow is updated
  hasAudio?: boolean; // Indicates if audio recording is available
  // instructions: HcInstructions; // instructions will be constructed from the HcMessages during the call, not user editable

  responseSetup: HcResponseSetup;
  enableAiInterpretation: boolean;
  saveAudio: boolean;
}

export enum HcVoiceOptions {
  VOICE = 'HcSmsVoiceOptions.voice',
  AUDIO_RECORDING = 'HcSmsVoiceOptions.audio_recording',
}

export interface HcMessage {
  text: string;
}


export interface HcResponseSetup {
  entries: HcResponseEntry[];
  timeout: number;
  timeoutAction: HcTimeOutAction;
}

export interface HcResponseEntry {
  key: string;
  phrases: string[];
  meaning: HcResponseMeaning;
  action: HcResponseAction;
}

export interface HcInstructions {
  prompt: string;
  timeout: string;
  languageAbbreviation: string;
}


/**
 * Generates health check call instructions in the specified language using flow's response setup
 * @param languageCode - The language code (e.g., 'en-US', 'fr-CA', 'es-ES')
 * @param responseSetup - The response setup from the flow containing response entries
 * @returns HcInstructions object with prompt and timeout messages
 */

export function getLanguageIdMessages(languageId: string): HcMessageStrings {
  return HcMessageStrings.HcStandardResponses.get(languageId);
}


